import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'channelName',
      type: 'select',
      label: '来源',
      clearable: true,
      filterable: true,
      placeholder: '请选择来源'
    },
    {
      field: 'month',
      type: 'datepicker',
      label: '选择月份',
      clearable: false,
      otherOptions: {
        'value-format': 'YYYY-MM',
        type: 'month'
      }
    },
    {
      field: 'cfddFlag',
      type: 'switch',
      label: '重复兜底开关'
    },
  ]
}
